import { api } from "./api";

const header = (token) => {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};


// Fetch Course
const fetchStudentCourses = () => {
  return api.get('course/all?parameter=student',);
};
const fetchCourses = (endpoint) => {
  return api.get(endpoint);
};


const fetchTeacher = (token) => {
  return api.get('course/all?parameter=teacher', header(token));
};
// fetch all courses
const fetchAllCourses = (token) => {
  return api.get('course/all', header(token));
};

const fetchSingleCourses = ( id) => {
  return api.get(`course/${id}`);
};


// Enrollment
const enrollCourse = (token, id) => {
  return api.post(`/enrolment/course/${id}`, {}, header(token));
};
const getEnrolledCourse = (token, userId) => {
  return api.get(`/enrolment/${userId}`,header(token));
};
// Lessson
// 
const updateLessonTrack = (token,data,id) => {
  return api.patch(`/lesson/track/${id}`, data, header(token));
};




export const CourseServices = {
  fetchStudentCourses,
  fetchTeacher,
  fetchSingleCourses,
  fetchAllCourses,
  fetchCourses,
  enrollCourse,
  getEnrolledCourse,
  updateLessonTrack
};